import React, { FC } from 'react'
import Image, { ImageProps } from '../image/Image'
import Spacing from '../spacing/Spacing'
import TextLink from '../text-link/TextLink'
import { Typography as Text } from '../typography/Typography'
import iconTextLinkHover from '../../assets/icons/icon-text-link-hover.svg'
import iconTextExternalLinkHover from '../../assets/icons/icon-text-link-external-hover.svg'
import { Icon } from '../text-link/TextLink'
import styled from 'styled-components'
import { Link } from 'gatsby'

export interface ArticleCardStyledProps {
	$externalUrl: boolean
}

export const ArticleCardStyled = styled(Link)<ArticleCardStyledProps>`
	display: block;
	&:hover ${Icon} {
		display: inline-block;
		${({ $externalUrl }) =>
			$externalUrl
				? 'background: url(' + iconTextExternalLinkHover + ');'
				: 'background: url(' + iconTextLinkHover + ');'}
	}
`

export interface ArticleCardProps {
	imageProps: ImageProps
	date: string
	subHeading: string
	href?: string
}

// @TODO check if passed url is external
const ArticleCard: FC<ArticleCardProps> = ({
	imageProps,
	date,
	subHeading,
	href = '#',
}) => (
	<ArticleCardStyled to={href} $externalUrl={false}>
		<Image {...imageProps} />
		<Spacing height={[24, 32]} />
		<Text variant="date">{date}</Text>
		<Spacing height={[12, 16]} />
		<TextLink
			href={href}
			text={{
				variant: 'subHeading',
				accent: 'navyBlue',
				lineHeight: 32,
				fontFamily: 'semiBold',
			}}
			icon="showOnHoverOnly"
			// render as button
			onClick={() => {}}
		>
			{subHeading}
		</TextLink>
	</ArticleCardStyled>
)

export default ArticleCard
